/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive, Renderer2, ElementRef, NgZone} from '@angular/core';
/**
 * The ink-bar is used to display and animate the line underneath the current active tab label.
 * \@docs-private
 */
export class MdInkBar {
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 * @param {?} _ngZone
 */
constructor(
private _renderer: Renderer2,
private _elementRef: ElementRef,
private _ngZone: NgZone) {}
/**
 * Calculates the styles from the provided element in order to align the ink-bar to that element.
 * Shows the ink bar if previously set as hidden.
 * @param {?} element
 * @return {?}
 */
alignToElement(element: HTMLElement) {
    this.show();

    this._ngZone.runOutsideAngular(() => {
      requestAnimationFrame(() => {
        this._renderer.setStyle(this._elementRef.nativeElement, 'left',
            this._getLeftPosition(element));
        this._renderer.setStyle(this._elementRef.nativeElement, 'width',
            this._getElementWidth(element));
      });
    });
  }
/**
 * Shows the ink bar.
 * @return {?}
 */
show(): void {
    this._renderer.setStyle(this._elementRef.nativeElement, 'visibility', 'visible');
  }
/**
 * Hides the ink bar.
 * @return {?}
 */
hide(): void {
    this._renderer.setStyle(this._elementRef.nativeElement, 'visibility', 'hidden');
  }
/**
 * Generates the pixel distance from the left based on the provided element in string format.
 * @param {?} element
 * @return {?}
 */
private _getLeftPosition(element: HTMLElement): string {
    return element ? element.offsetLeft + 'px' : '0';
  }
/**
 * Generates the pixel width from the provided element in string format.
 * @param {?} element
 * @return {?}
 */
private _getElementWidth(element: HTMLElement): string {
    return element ? element.offsetWidth + 'px' : '0';
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'md-ink-bar, mat-ink-bar',
  host: {
    'class': 'mat-ink-bar',
  },
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
{type: NgZone, },
];
}

function MdInkBar_tsickle_Closure_declarations() {
/** @type {?} */
MdInkBar.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdInkBar.ctorParameters;
/** @type {?} */
MdInkBar.prototype._renderer;
/** @type {?} */
MdInkBar.prototype._elementRef;
/** @type {?} */
MdInkBar.prototype._ngZone;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
